
import { CreateElement } from "vue";
import { DataModules } from "@/store/modules/data";
import { IBasket } from "@/models/baskets";
import { InvoiceCategoryCode } from "@/models/invoices";
import { QUERY_PARAMS } from "@/data/constants";
import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

/**

((params, host = "?") => {
  for (const key in params) {
    params[key] = encodeURI(JSON.stringify(params[key]));
  }
  return host + new URLSearchParams(params).toString();
})({
  product: {
    product_id: "63250798-065d-1ed5-6e6f-6174e234e98d",
    billing_cycle_months: 1
  },
  fields: {
    domain_name: "example.com"
  }
});


((params, host = "?") => {
  for (const key in params) {
    params[key] = encodeURI(JSON.stringify(params[key]));
  }
  return host + new URLSearchParams(params).toString();
})({
  product: {
    product_id: "d085e69d-5623-7197-964a-018e940d4237",
    billing_cycle_months: 1,
    options: [
      {
        product_id: "785d26e9-6783-d167-887a-614502e70439",
        billing_cycle_months: 1
      }
    ]
  }
});

*/

@Component({
  computed: {
    ...mapGetters({
      isClientAuthenticated: "auth/client/isAuthenticated",
      isGuestAuthenticated: "auth/guest/isAuthenticated"
    })
  }
})
export default class RapidOrder extends Vue {
  // Props

  @Prop({ default: null })
  public readonly query!: {
    currency?: string;
    fields?: string;
    product: string;
  };

  // Data

  public isClientAuthenticated!: boolean;
  public isGuestAuthenticated!: boolean;

  //  Life-cycle methods

  public async created() {
    try {
      await this.checkAuthState();
      const basket = await this.createOrder();
      await this.saveProvisionFields(basket.id, basket.products[0].id);
      this.$router
        .push({ name: "orderCheckoutStep", replace: true })
        .catch(err => err);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.$router.push({ name: "order", replace: true }).catch(err => err);
    }
  }

  public render(h: CreateElement) {
    return h("is-loading", {
      props: { if: true },
      attrs: { isAbsolute: true }
    });
  }

  // Methods

  /**
   * @name checkAuthState
   * @desc Here we check the current auth state and create a new token if required
   */

  public checkAuthState() {
    if (this.isClientAuthenticated || this.isGuestAuthenticated) return;
    return this.$store.dispatch("auth/guest/createToken");
  }

  /**
   * @name decodeQueryParam
   * @desc Here we decode and parse a given query param
   */

  public decodeQueryParam(key: string) {
    const param = this.query[key];
    if (!param) throw `Missing param: ${key}`;
    const decoded = decodeURI(param);
    return JSON.parse(decoded);
  }

  /**
   * @name createOrder
   * @desc Here we create a new order using decoded 'product' param
   * @docs https://demoapi.upmind.io/doc/#api-Admin_Orders-PostAdminOrders
   * @returns Basket object
   */

  public async createOrder(): Promise<IBasket> {
    return this.$store.dispatch(`data/${DataModules.BASKETS}/create`, {
      data: {
        category_slug: InvoiceCategoryCode.NEW_CONTRACT,
        currency_code: this.query[QUERY_PARAMS.CURRENCY_CODE],
        products: [
          {
            quantity: 1,
            ...this.decodeQueryParam("product")
          }
        ]
      }
    });
  }

  /**
   * @name saveProvisionFields
   * @desc Here we save provision field values passing decoded 'fields' param
   * @docs https://demoapi.upmind.io/doc/#api-Provision_Blueprint_Fields-PutOrdersOrder_idProductsOrder_product_idProvision_fieldsValues
   */

  public async saveProvisionFields(
    basketId: IBasket["id"],
    productId: IBasket["products"][0]["id"]
  ) {
    if (!this.query.fields) return;
    await this.$store.dispatch(
      `data/${DataModules.PROVISIONING_BASKET_PRODUCTS}/updateValues`,
      {
        basketId,
        productId,
        data: {
          provision_field_values: this.decodeQueryParam("fields"),
          validate: 0
        }
      }
    );
  }
}
